import type { DeliveryStatus } from "@types_def/models/delivery.types";
import type { DeliveryStatusAttributes } from "@utils/constants/DeliveryStatus/delivery-status-attributes";

import { deliveryStatusAttributes } from "@utils/constants/DeliveryStatus/delivery-status-attributes";

export function getDeliveryAttributesByStatus(deliveryStatus: DeliveryStatus) {
  return (
    deliveryStatusAttributes.find((c) => c.key === deliveryStatus) ?? deliveryStatusAttributes[0]
  );
}

export function getDeliveryAttributeByStatus(
  deliveryStatus: DeliveryStatus,
  deliveryStatusAttribute: keyof DeliveryStatusAttributes
) {
  return getDeliveryAttributesByStatus(deliveryStatus)[deliveryStatusAttribute];
}
